<template>
    <div class="app-splash-screen" v-if="appLoading">
      <div class="app-splash-screen-content">
        <div class="ui-w-60">
          <img src="/Images/sos-logo60x60-white.png" style="width: 30px; height: 30px;">
        </div>
      </div>
    </div>
</template>

<!-- Splash screen -->
<style>
  .app-splash-screen {
    background: #fff;
    position: fixed;
    display: block;
    z-index: 99999999;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    opacity: 1;
    transition: opacity .3s;
  }

  .app-splash-screen-content {
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-animation: appSplashScreenAnimation 1.2s ease-in-out 0s infinite;
    animation: appSplashScreenAnimation 1.2s ease-in-out 0s infinite;
  }

  @-webkit-keyframes appSplashScreenAnimation {
    0%,
    20% {
      -webkit-transform: translate(-50%, -50%) rotateY(0);
      transform: translate(-50%, -50%) rotateY(0);
    }
    50% {
      -webkit-transform: translate(-50%, -50%) rotateY(180deg);
      transform: translate(-50%, -50%) rotateY(180deg);
    }
    80%,
    100% {
      -webkit-transform: translate(-50%, -50%) rotateY(360deg);
      transform: translate(-50%, -50%) rotateY(360deg);
    }
  }

  @keyframes appSplashScreenAnimation {
    0%,
    20% {
      -webkit-transform: translate(-50%, -50%) rotateY(0);
      transform: translate(-50%, -50%) rotateY(0);
    }
    50% {
      -webkit-transform: translate(-50%, -50%) rotateY(180deg);
      transform: translate(-50%, -50%) rotateY(180deg);
    }
    80%,
    100% {
      -webkit-transform: translate(-50%, -50%) rotateY(360deg);
      transform: translate(-50%, -50%) rotateY(360deg);
    }
  }
</style>
<!-- / Splash screen -->

<script>
export default {
  data(){
    return {

    }
  },
  computed: {
    appLoading(){
      return this.$store.state.appLoading;
    }
  }
}
</script>
